import { Injectable } from '@angular/core';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { PlantExternalIdsState } from './plant-external-ids.state';
import { PlantExternalIDsInitialState, PlantExternalIDsLoad } from './plant-external-ids.actions';
import { PlantExternalId, PlantExtIdsRequestModel } from '../models';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class PlantExternalIdsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(PlantExternalIdsState.getLoaded);
  list$: Observable<PlantExternalId[]> = this.store.select(PlantExternalIdsState.getList);

  constructor(private store: Store) {}

  loadAll(params: PlantExtIdsRequestModel): void {
    this.store.dispatch(new PlantExternalIDsLoad(params));
  }

  setInitialState(): void {
    this.store.dispatch(new PlantExternalIDsInitialState());
  }
}
